import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container policies-page" }
const _hoisted_2 = { class: "row d-flex align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "col-12"
}
const _hoisted_4 = {
  key: 1,
  class: "col-12"
}
const _hoisted_5 = { class: "polices_header text-center" }
const _hoisted_6 = { class: "policies_content" }
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[0] || (_cache[0] = [
            _createStaticVNode("<h2 class=\"placeholder-glow\" data-v-6a6324d0><span class=\"placeholder col-3\" data-v-6a6324d0></span></h2><p class=\"placeholder-glow\" data-v-6a6324d0><span class=\"placeholder col-8\" data-v-6a6324d0></span><span class=\"placeholder col-8\" data-v-6a6324d0></span><span class=\"placeholder col-8\" data-v-6a6324d0></span><span class=\"placeholder col-8\" data-v-6a6324d0></span></p>", 2)
          ])))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.returnContent?.name), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                innerHTML: _ctx.returnContent?.text
              }, null, 8, _hoisted_7)
            ])
          ]))
    ])
  ]))
}